export default "__VITE_ASSET__bIqZXC3K__"